// store/modules/word.js
export default {
  namespaced: true,

  state: {
    // 单词库（格式：{id, word, phoneticEn, phoneticUs, meaning}）
    wordLibrary: [],
    // 用户进度（格式：{wordId, stage, nextReviewTime, isMastered}）
    userProgress: [],
    // 当日待复习单词（过滤+排序后）
    todayReviewList: [],
  },

  mutations: {
    SET_WORD_LIBRARY(state, library) {
      state.wordLibrary = library;
    },

    SET_USER_PROGRESS(state, progress) {
      state.userProgress = progress;
    },

    SET_TODAY_REVIEW_LIST(state, list) {
      state.todayReviewList = list;
    },

    UPDATE_WORD_PROGRESS(state, { wordId, stage, nextReviewTime, isMastered }) {
      const progress = state.userProgress.find(
        (item) => item.wordId === wordId
      );
      if (progress) {
        progress.stage = stage;
        progress.nextReviewTime = nextReviewTime;
        progress.isMastered = isMastered;
      }
    },
  },

  actions: {
    // 初始化：从本地存储/后端加载数据
    init({ commit, dispatch }) {
      const savedProgress = localStorage.getItem("wordProgress");
      const savedLibrary = localStorage.getItem("wordLibrary");
      if (savedProgress) commit("SET_USER_PROGRESS", JSON.parse(savedProgress));
      if (savedLibrary) commit("SET_WORD_LIBRARY", JSON.parse(savedLibrary));
      dispatch("calcTodayReviewList"); // 计算今日待复习列表
    },

    // 计算今日待复习单词（按优先级排序）
    calcTodayReviewList({ state, commit }) {
      const now = new Date().getTime();
      const todayReviewList = state.userProgress
        .filter((item) => !item.isMastered) // 排除已掌握
        .map((item) => {
          // 关联单词详情
          const word = state.wordLibrary.find((w) => w.id === item.wordId);
          return { ...item, ...word };
        })
        .filter((item) => new Date(item.nextReviewTime).getTime() <= now) // 只保留已到期
        .sort((a, b) => {
          // 排序：过期越久优先级越高，阶段越低优先级越高
          const aTime = new Date(a.nextReviewTime).getTime();
          const bTime = new Date(b.nextReviewTime).getTime();
          if (aTime !== bTime) return aTime - bTime; // 先按到期时间（早的在前）
          return a.stage - b.stage; // 同时间按阶段（低阶段在前）
        });
      commit("SET_TODAY_REVIEW_LIST", todayReviewList);
    },

    // 处理用户复习反馈（记得/不记得）
    handleReview({ state, commit, dispatch }, { wordId, result }) {
      const progress = state.userProgress.find(
        (item) => item.wordId === wordId
      );
      if (!progress) return;

      let newStage = progress.stage;
      // 根据反馈更新阶段
      if (result === "remember") {
        newStage = Math.min(progress.stage + 1, 5); // 最多到阶段5
      } else {
        newStage = 1; // 不记得则重置为阶段1
      }

      // 计算下次复习时间（根据当前阶段）
      const intervals = [
        10 * 60 * 1000,
        24 * 60 * 60 * 1000,
        3 * 24 * 60 * 60 * 1000,
        7 * 24 * 60 * 60 * 1000,
        15 * 24 * 60 * 60 * 1000,
      ];
      const nextTime = new Date(Date.now() + intervals[newStage - 1]);
      const nextReviewTime = nextTime.toISOString();

      // 阶段5且记得 → 标记为掌握
      const isMastered = newStage === 5 && result === "remember";

      // 更新状态
      commit("UPDATE_WORD_PROGRESS", {
        wordId,
        stage: newStage,
        nextReviewTime,
        isMastered,
      });

      // 保存并更新待复习列表
      localStorage.setItem("wordProgress", JSON.stringify(state.userProgress));
      dispatch("calcTodayReviewList");
    },
  },

  getters: {
    todayReviewCount: (state) => state.todayReviewList.length,
    masteredWordsCount: (state) =>
      state.userProgress.filter((item) => item.isMastered).length,
    totalWordsCount: (state) => state.wordLibrary.length,
  },
};
